import { render, staticRenderFns } from "./MRadiobutton.vue?vue&type=template&id=3bc6280e"
import script from "./MRadiobutton.vue?vue&type=script&lang=js"
export * from "./MRadiobutton.vue?vue&type=script&lang=js"
import style0 from "./MRadiobutton.vue?vue&type=style&index=0&id=3bc6280e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports